module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ARCHITECTURE-9e6e7227adad8315ba4f5c6078a8a44d.png";